<template>
  <VTable
    class="managers-manager"
    :items="computedItems"
    :fields="fields"
    :checked-rows="checkedItems"
    :loading="loading"
    :on-toggle-row="onToggleRow"
    :on-input-search="onInputSearch"
    :on-edit-item="onEditItem"
    :on-delete-item="onDeleteItem"
    :on-click-to-add="onClickToAdd"
    searchPlaceholder="Search for user...."
    hover
    striped
    border
    small
    fixed
    dark
  >
    <template #footer>
      <VPagination :items-count="itemsCount"  class="user-manager-card__footer-pagination"/>
    </template>
  </VTable>
</template>
<script>
import {
  createManagersManagerMixin,
  managersManagerStore
} from "@/mixins/managersManagerMixin";
import { authStore, createAuthStoreMixin } from "@/mixins/authStoreMixin";

import { debounce } from "@/utils/debounce";
import ModalType from "@/utils/dictionaries/modalType";
import { getUserRole } from "@/utils/validation/user";
import moment from "moment";

export default {
  name: "VUserManagerTable",

  mixins: [createManagersManagerMixin(),createAuthStoreMixin()],

  components: {
  },

  data: () => {
    return {
      loading: false,
      lastSearchTerm: null,
      searchFn: () => {},
      checkedItems: []
    }
  },

  computed: {
    isReload() {
      return this[authStore.getterTypes.GETTER_PAGE_RELOAD];
    },
    fields() {
      return [
        { key: "rowId", label: "" },
        { key: "user_avatar", label: "Avatar", _style: "min-width: 65px" },
        {
          key: "firstName",
          label: "First Name",
          _style: "min-width: 125px",
          _classes: "username"
        },
        {
          key: "lastName",
          label: "Last Name",
          _style: "min-width: 125px",
          _classes: "username"
        },
        {
          key: "user_username",
          label: "Username",
          _style: "min-width: 125px",
          _classes: "username"
        },
        {
          key: "user_email",
          label: "User Mail",
          _style: "min-width: 150px",
          _classes: "user-mail"
        },
        {
          key: "user_phone_number",
          label: "Phone Number",
          _style: "min-width: 150px",
          _classes: "user-phone"
        },
        {
          key: "createdAt",
          label: "Date Created",
          _style: "min-width: 170px",

        },
        {
          key: "text_role",
          label: "Role",
          _style: "min-width: 150px",
          _classes: "user-role"
        },
        { key: "action", _style: "max-width: 20px;min-width:20px" }
      ]
    },
    items() {
      return this[managersManagerStore.getterTypes.GETTER_USERS];
    },
    itemsCount() {
      return this[managersManagerStore.getterTypes.GETTER_USERS_COUNT];
    },
    computedItems() {
      return this.items && this.items.map(item => {
        return {
          ...item,
          user_id: item.id,
          user_avatar: item.avatar,
          user_username: item.username,
          user_email: item.email,
          user_phone_number: item.phoneNumber || '',
          user_role: item.role,
          text_role: getUserRole(item),
          user_isManager: true,
          user_bio: item.bio,
          user_password: item.password,
          user_firstName: item.firstName,
          user_lastName: item.lastName,
          createdAt: item.createdAt ? moment(item.createdAt).format('lll') : '',
        }
      })
    }
  },

  watch: {
    isReload(newValue){
      this.loadData();
    },
    $route() {
      this.loadData()
    }
  },

  async created() {
    this[managersManagerStore.actionTypes.ACTION_JOIN_TO_USER_MANAGER]()
    await this.loadData()

    this.searchFn = debounce.call(
      this,
      async term => {
        const query = {
          ...this.$route.query,
          search: term
        }

        if (!query.search && query.offset) {
          query.offset = 0;
        }

        this.$router
          .push({
            query
          })
          .catch(() => {})
      },
      200
    )
  },

  methods: {
    onToggleRow({ item }) {
      this.checkedItems = [item]
    },
    onInputSearch(t) {
      this.searchFn(t)
    },
    onEditItem(item) {
      this.$modals.open(ModalType.CreateUserModal, { ...item, user_isEdit: true })
    },
    getLastUsers() {
      return this.items
        .map(u => ({ created_at: u.createdAt, id: u.id, role: u.role }));
    },
    onDeleteItem(item) {
      const user = this.checkedItems && this.checkedItems[0]

      const id = user.id

      const lastUsers = this.getLastUsers().filter(u => u.id !== id)

      const deleteAction = () => {
        this[managersManagerStore.actionTypes.ACTION_DELETE_USER]({
          users: [id],
          lastUsers
        });

        if (this.items.length === 1) {
          this.$router.push({
            query: ""
          });
        }

        this.$modals.close(ModalType.ConfirmationModal)
      }

      this.$modals.open(ModalType.ConfirmationModal, {
        title: 'Deletion',
        body: `Are you sure you want to delete <strong>${ user.user_username }</strong> user?`,
        buttonText: 'Delete',
        onClickButton: deleteAction
      })
    },
    onClickToAdd() {
      this.$modals.open(ModalType.CreateUserModal, { isManager: true })
    },
    async loadData() {
      this.loading = true;
      await this[managersManagerStore.actionTypes.ACTION_LOAD_USERS]({
        skip: this.$route.query.skip,
        take: this.$route.query.take,
        search: this.$route.query.search
      })
      await this[authStore.mutationTypes.MUTATION_SET_PAGE_RELOAD](false)
      this.loading = false
    }
  }
};
</script>
